import React, { useState, useEffect } from "react";
import { Button, Dialog, OutlinedInput, Typography, Stack, Box, DialogActions, DialogContent } from "@mui/material";
import Slide from "@mui/material/Slide";
import ApiService from "../../services/api-service";
import Loader from "../../components/Loader";
import notifier from "../../components/Notifier";
import { Calendar } from "react-iconly";
import { disableDates, getErrorString } from "../../constants/function";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AuctionPopup(props) {
  const { t } = useTranslation("common");
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [fraction, setFraction] = useState(null);
  const [fractions, setFractions] = useState({});
  
  useEffect(() => {
    console.log("props", props);
  
    if (props.type === "music" && props.isMaster) {
      console.log("Calling getNftFractions with assetId:", props.assetId);
      // Use assetId to get fractions
      getNftFractions(props.assetId);
    } else {
      // Set fraction to undefined instead of using props.rank
      console.log("Setting fraction to undefined");
      setFraction(undefined);
    }
  }, [props.type, props.isMaster, props.assetId]);
  
  console.log("assetId", props.assetId);
  
  const getNftFractions = async (assetId) => {
    try {
      console.log("getNftFractions started with assetId:", assetId);
  
      setIsLoading(true);
      const response = await ApiService.GET_NFT_FRACTIONS(`${assetId}&onAuction=false`);
      console.log("Fractions response:", response);
  
      setFractions(response.result || {}); // Set fractions based on the response
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  

  const validateDates = (startDate, endDate) => {
    return new Date(startDate) <= new Date(endDate);
  };

  const bid = async () => {
    if (!validateDates(startDate, endDate)) {
      notifier.error(t("invalidDate"));
      return;
    }
    try {
      const payload = {
        startingPrice: amount,
        startDate,
        endDate,
        type: props.type || "playlist",
        assetId: props.assetId,
        rank: props.type === "music" ? fraction : 1,
      };
      console.log("Payload being sent for auction:", payload);

      
      setIsLoading(true);
      const response = await ApiService.AUCTION_NFT_V2(payload);
      console.log(response, "response");
      notifier.success(t("notifier.success.toast15"));
      props.handleClose({ amount });
    } catch (error) {
      notifier.error(getErrorString(error));
    } finally {
      setIsLoading(false);
    }
  };
  

  const currentDate = new Date().toISOString().split("T")[0];

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => props.handleClose(false)}
      PaperProps={{
        style: {
          backgroundColor: "#171515",
          color: "#000000",
          borderRadius: 16,
          padding: 16,
          maxHeight: "80vh",
        },
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <Stack spacing={1}>
        {props.type === "music" && props.isMaster && (
          <Box className="__sell_nft_fractions">
            <Typography>{t("auctionPopup.text1")}</Typography>
            <Typography>{fractions.availableFractions || 0}/{fractions.totalFractions || 0}</Typography>
            <Stack className="_nft_fractions_box" sx={{ maxHeight: "70% !important" }}>
              {fractions.fractions?.map((f, index) => (
                <Typography
                  onClick={() => setFraction(f === fraction ? null : f)}
                  className={`_fraction ${fraction === f ? "_fraction_selected" : ""}`}
                  key={index}
                >
                  {f}
                </Typography>
              ))}
            </Stack>
          </Box>
        )}

        <Typography>{t("auctionPopup.text2")}</Typography>
        <DialogContent>
          <OutlinedInput
            sx={{ backgroundColor: "#262626", width: "100%" }}
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
            placeholder={t("auctionPopup.text3")}
            endAdornment={<Typography sx={{ padding: "5px", fontSize: "12px" }}>{t("auctionPopup.text4")}</Typography>}
          />
        </DialogContent>

        <Typography>{t("auctionPopup.text5")}</Typography>
        <DialogContent>
          <Box className="__upload_inputbox">
            <input
              id="auctionFrom"
              min={currentDate}
              type="date"
              className="__input date-click _cp"
              placeholder={t("auctionPopup.text5")}
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                disableDates("auctionEnddate", "min", e.target.value);
              }}
            />
            <Calendar className="__input_icon _cp" set="light" primaryColor="white" />
          </Box>
        </DialogContent>

        <Typography>{t("auctionPopup.text6")}</Typography>
        <DialogContent>
          <Box className="__upload_inputbox">
            <input
              id="auctionEnddate"
              type="date"
              className="__input date-click _cp"
              placeholder={t("auctionPopup.text6")}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              disabled={!startDate}
            />
            <Calendar className="__input_icon" set="light" primaryColor="white" />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => props.handleClose(false)}>{t("auctionPopup.button1")}</Button>
          <Button
            variant="contained"
            onClick={bid}
            disabled={
              props.type === "music"
                ? !amount || !fraction || !startDate || !endDate
                : !amount || !startDate || !endDate
            }
          >
            {t("auctionPopup.button2")}
          </Button>
        </DialogActions>
      </Stack>

      {isLoading && <Loader wait />}
    </Dialog>
  );
}
